import React from "react";
import PropTypes from "prop-types";
import { Container, Name, About, Description, Title, Date } from "./styles";
import { Cards } from "../styles";
import {
	STAR_RATE_FALSE,
	STAR_RATE_TRUE,
} from "@website-builder/utilities-index";

const Card = ({ description, name, about, stars, title, date }) => {
	let star = [];
	for (let i = 1; i <= 5; i++) {
		if (i <= parseInt(stars)) {
			star.push(
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="1em"
					height="1em"
					viewBox="0 0 1024 1024"
				>
					<path
						d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5c-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1l-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2c17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9l183.7-179.1c5-4.9 8.3-11.3 9.3-18.3c2.7-17.5-9.5-33.7-27-36.3z"
						fill={STAR_RATE_TRUE}
					/>
				</svg>,
			);
		} else {
			star.push(
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="1em"
					height="1em"
					viewBox="0 0 1024 1024"
				>
					<path
						d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5c-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1l-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2c17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9l183.7-179.1c5-4.9 8.3-11.3 9.3-18.3c2.7-17.5-9.5-33.7-27-36.3z"
						fill={STAR_RATE_FALSE}
					/>
				</svg>,
			);
		}
	}

	let DateObj;
	if (date) {
		DateObj =
			date.split("-")[1] +
			"-" +
			date.split("-")[2].split(" ")[0] +
			"-" +
			date.split("-")[0];
	}

	return (
		<Container className="swiper-slide">
			<div>
				<ul className="top">
					<li> {star}</li>
					<li>
						<Date>{DateObj}</Date>
					</li>
				</ul>
				<Title>{title}</Title>
				<Description>{description}</Description>
				<div className="mentorInfo">
					<Name>{name}</Name>
					<About>{about}</About>
				</div>
			</div>
		</Container>
	);
};

Cards.propTypes = {
	title: PropTypes.string,
	date: PropTypes.string,
	description: PropTypes.string,
	name: PropTypes.string,
	about: PropTypes.string,
	stars: PropTypes.number,
};

Cards.defaultProps = {
	title: "",
	date: "",
	description: "",
	name: "",
	about: "",
	stars: 5,
};

export default Card;
